import Svg, { Defs, LinearGradient, Path, Rect, Stop } from 'react-native-svg';
import { IconProps } from '@/common/types/general';

export function IconAgentIRS({ width = 56, height = 53 }: IconProps) {
  return (
    <Svg width={width} height={height} fill="none" viewBox="0 0 56 53">
      <Rect
        width="27.811"
        height="32.934"
        x=".231"
        y="11.627"
        fill="#C4E8E4"
        rx="2.91"
      />
      <Path
        fill="#FCF5F2"
        d="M3.72 27.304h12.344v3.354H3.72zM3.621 16.075H16.12v1.483H3.621zM20.76 27.304h3.757v3.354H20.76zM3.72 32.001h12.344v3.354H3.72zM20.76 32.001h3.757v3.354H20.76zM3.72 36.696h12.344v3.354H3.72z"
      />
      <Path fill="#A6DDD6" d="M20.76 36.696h3.757v3.354H20.76z" />
      <Rect
        width="43.911"
        height="52"
        x="12.088"
        y=".5"
        fill="#fff"
        rx="4.595"
      />
      <Path
        fill="#FDBD9A"
        d="M17.597 26.734h19.49v5.296h-19.49zM17.597 19.325h19.49v5.296h-19.49z"
      />
      <Path
        fill="#7CCCC5"
        d="M44.502 26.734h5.932v5.296h-5.932zM44.502 19.325h5.932v5.296h-5.932z"
      />
      <Path
        fill="#FDBD9A"
        d="M17.597 34.148h19.49v5.296h-19.49zM17.597 41.565h19.49v5.296h-19.49z"
      />
      <Path
        fill="#7CCCC5"
        d="M44.502 34.148h5.932v5.296h-5.932zM44.502 41.565h5.932v5.296h-5.932z"
      />
      <Path
        fill="url(#irs-agent-a)"
        d="M34.92 8.483c-.029-.31-.154-.55-.376-.721-.22-.175-.533-.262-.941-.262-.27 0-.495.035-.675.105a.88.88 0 0 0-.405.292.703.703 0 0 0-.14.417c-.005.13.02.243.077.342.059.098.143.186.253.262.112.073.247.137.405.194.157.056.334.105.531.147l.743.169a5.23 5.23 0 0 1 1.13.371c.33.155.605.34.828.553.224.214.395.46.51.738.115.279.174.59.177.937-.003.546-.14 1.014-.413 1.405-.273.39-.666.69-1.177.898-.51.209-1.124.313-1.844.313-.723 0-1.353-.109-1.89-.325-.537-.217-.955-.546-1.253-.987-.298-.442-.452-1-.46-1.675h2c.017.278.091.51.223.696.133.185.314.326.545.422.233.095.503.143.81.143.28 0 .52-.038.717-.114.2-.076.353-.181.46-.316a.748.748 0 0 0 .164-.464.64.64 0 0 0-.152-.418 1.15 1.15 0 0 0-.455-.304 4.673 4.673 0 0 0-.776-.24l-.903-.211c-.749-.172-1.338-.449-1.768-.831-.43-.386-.644-.906-.641-1.561a2.319 2.319 0 0 1 .43-1.405c.29-.402.69-.716 1.202-.941.512-.225 1.096-.338 1.751-.338.67 0 1.25.114 1.743.342.495.225.878.542 1.151.95.273.407.412.88.418 1.417h-2Z"
      />
      <Path
        fill="url(#irs-agent-b)"
        d="M21.954 14.533v-8.64h3.57c.646 0 1.204.116 1.674.35.473.23.837.562 1.093.995.256.43.384.941.384 1.532 0 .599-.131 1.108-.393 1.527a2.506 2.506 0 0 1-1.113.954c-.481.216-1.05.325-1.709.325h-2.257V9.93h1.869c.315 0 .578-.04.789-.122a.992.992 0 0 0 .485-.38c.11-.172.165-.39.165-.658 0-.267-.055-.488-.165-.662a.99.99 0 0 0-.485-.397 2.035 2.035 0 0 0-.79-.135h-1.029v6.957h-2.088Zm4.864-3.949 2.152 3.949h-2.278l-2.11-3.949h2.236Z"
      />
      <Path
        fill="url(#irs-agent-c)"
        d="M19.82 5.893v8.64h-2.088v-8.64h2.089Z"
      />
      <Defs>
        <LinearGradient
          id="irs-agent-a"
          x1="30"
          x2="38.636"
          y1="5.774"
          y2="12.627"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FE7165" />
          <Stop offset="1" stopColor="#FF8D78" />
        </LinearGradient>
        <LinearGradient
          id="irs-agent-b"
          x1="21.954"
          x2="30.41"
          y1="5.893"
          y2="12.759"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FE7165" />
          <Stop offset="1" stopColor="#FF8D78" />
        </LinearGradient>
        <LinearGradient
          id="irs-agent-c"
          x1="17.732"
          x2="21.679"
          y1="5.893"
          y2="6.846"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FE7165" />
          <Stop offset="1" stopColor="#FF8D78" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
